import { Iconify } from "@repo/design-system/components/ui";
import { ToastService } from "@/services";
import PropTypes from "prop-types";
import { memo, useCallback, useState } from "react";
import "./CopyToClipboard.scss";

const CopyToClipboardComponent = ({
    value,
    showValue = true,
    truncateAt = 30,
    className = "",
    copyTitle = "Copy",
    copiedTitle = "Copied",
    copyMessage = "Text copied to clipboard",
}) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopyClick = useCallback(() => {
        if (!value) return;

        // Modern API
        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(value);
        } else {
            // Fallback (older browsers)
            const textarea = document.createElement("textarea");
            textarea.value = value;
            textarea.style.position = "fixed";
            textarea.style.opacity = "0";
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
        }

        setIsCopied(true);
        ToastService.success({ description: copyMessage });
        setTimeout(() => setIsCopied(false), 1200);
    }, [value]);

    const displayValue = showValue && value?.length > truncateAt
        ? `${value.slice(0, truncateAt)}…` : value;

    return (
        // <div className={`copy-to-clipboard ${className}`}>
        <button type="button" className="copy-to-clipboard__button"
            onClick={handleCopyClick}>
            <Iconify ttLabel={isCopied ? copiedTitle : copyTitle}
                targetId={isCopied ? "copied" : "copy"}
                icon={isCopied ? "mdi:check-circle-outline" : "mdi:content-copy"}
                width={16} />
        </button>
        // </div>
    );
};

CopyToClipboardComponent.propTypes = {
    value: PropTypes.string.isRequired,
    showValue: PropTypes.bool,
    truncateAt: PropTypes.number,
    className: PropTypes.string,
    copyTitle: PropTypes.string,
    copiedTitle: PropTypes.string,
};

export const CopyToClipboard = memo(CopyToClipboardComponent);